import { FC, ReactNode } from "react";
import styles from "./BusinessCard.module.scss";

interface IBusinessCardProps {
    children: ReactNode;
}

export const BusinessCard: FC<IBusinessCardProps> = ({ children }) => {
    return (
        <div className={styles.businessCard}>
            { children }
        </div>
    );
}